import { createSlice } from '@reduxjs/toolkit'
import { ofType } from 'redux-observable'
import { getHeaders } from '../../utils/authHelper'
import { ENV } from '../../utils/environment'
import { HTTP, successResponse } from '../../utils/httpHelper'
import { mergeMap } from 'rxjs/operators'
import { of } from 'rxjs'

export const BOOKMARKS_FEATURE_KEY = 'bookmarks'

const resetState = (state) => {
	delete state.error
	state.date = new Date().getTime()
}

export const bookmarksSlice = createSlice({
	name: BOOKMARKS_FEATURE_KEY,
	initialState: {
		bookmarks: [],
		loading: true,
	},
	reducers: {
		GET_BOOKMARKS: (state, action) => resetState(state),
		GET_BOOKMARKS_SUCCESS: (state, action) => {
			state.bookmarks.push(...action.payload.data)
			state.date = new Date().getTime()
			state.loading = false
		},
		GET_BOOKMARKS_ERROR: (state, action) => {
			state.date = new Date().getTime()
			state.error = true
			state.loading = false
		},
		CLEAR_BOOKMARKS: (state) => {
			state.bookmarks = []
			resetState(state)
		},
	},
})

/*
 * Export reducer for store configuration.
 */
export const bookmarksReducer = bookmarksSlice.reducer

/*
 * Export actions
 */
export const { GET_BOOKMARKS, GET_BOOKMARKS_SUCCESS, GET_BOOKMARKS_ERROR, CLEAR_BOOKMARKS } = bookmarksSlice.actions

/*
 * Set up the redux-observable epic
 */
export const bookmarksEpic = (action$) => action$.pipe(ofType(GET_BOOKMARKS.type), mergeMap(bookmarksService(action$)))

/*
 * Do API calls
 */
export const bookmarksService = (action$) => (action) => {
	switch (action.type) {
		case GET_BOOKMARKS.type: {
			return HTTP.GET(
				ENV.BASE_URL + ENV.GET_BOOKMARKS.replace('{GENREF}', action.payload.genRefs),
				getHeaders(),
				getBookmarksSuccess,
				getBookmarksError,
				false,
				action$.pipe(ofType(GET_BOOKMARKS))
			)
		}
	}
}

const getBookmarksSuccess = (response) => {
	return {
		type: GET_BOOKMARKS_SUCCESS.type,
		payload: { ...successResponse(response) },
	}
}

const getBookmarksError = (response) =>
	of({
		type: GET_BOOKMARKS_ERROR.type,
	})
